import {parseData} from 'Utils/helpers/SRListHelpers';
import {SortOrder} from 'Utils/enums';

export const getBenefitsGirdData = (
  tableData,
  sortOrder = SortOrder.DESCENDING,
  currentSortCriteria,
  isSortingEnabled = true,
) => {
  const header = [
    {label: 'Benefit', value: 'benefit'},
    {label: 'Vendor', value: 'vendor'},
    {label: 'Vendor Code', value: 'code'},
  ];

  let hideColumns = {};

  return parseData(
    header,
    tableData,
    sortOrder,
    currentSortCriteria,
    isSortingEnabled,
    hideColumns,
  );
};
